import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
 import { ToastrService } from 'ngx-toastr';
 import { BaseService } from '../shared/services/base.service';
import { TranslationService } from '../shared/i18n/translation.service';
import { environment } from 'src/environments/environment.prod';
@Injectable({
    providedIn: 'root',
})
export class ActivityService extends BaseService<any>  {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        }),
    };
    langId: number=1;
    API_URL = `${environment.apiUrl}/Activity`;
    API_URLFind = `${environment.apiUrl}/Activity/Find`;
    API_URLGetAll = `${environment.apiUrl}/Activity`;
    API_URLAdd = `${environment.apiUrl}/Activity`;
    API_URLUpdate = `${environment.apiUrl}/Activity`;
    API_URLDelete = `${environment.apiUrl}/Activity`;
    API_URLGetById = `${environment.apiUrl}/Activity`;

    constructor(@Inject(HttpClient) http: HttpClient, public toastr: ToastrService, public translationServices: TranslationService) {
        super(http, toastr, translationServices);
    }
  
 
}
